/**
 * KaTeX Math Rendering
 * 
 * Configures and initializes KaTeX auto-render for math equations.
 * Supports both display ($$..$$) and inline ($..$ or \(...\)) math.
 */

import katex from 'katex'
import renderMathInElement from 'katex/contrib/auto-render'

// KaTeX auto-render configuration
const KATEX_OPTIONS = {
  delimiters: [
    { left: '$$', right: '$$', display: true },
    { left: '$', right: '$', display: false },
    { left: '\\(', right: '\\)', display: false },
    { left: '\\[', right: '\\]', display: true }
  ],
  throwOnError: false,
  trust: true
}

/**
 * Render all math elements in the document body
 */
export function renderMath() {
  renderMathInElement(document.body, KATEX_OPTIONS)
}

/**
 * Render math elements within a specific container
 * @param {HTMLElement} element - The container element to render math in
 */
export function renderMathIn(element) {
  renderMathInElement(element, KATEX_OPTIONS)
}

/**
 * Initialize KaTeX rendering on page load
 */
export function initKatex() {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', renderMath)
  } else {
    renderMath()
  }

  // Re-render after Turbo navigation (if using Turbo)
  document.addEventListener('turbo:load', renderMath)
}

// Make katex available globally for advanced usage
window.katex = katex

// Auto-initialize when imported
initKatex()
